import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HomeHeroSection from "../components/Home-herosection";
import AboutHeroPage from "../components/About-heropage";
import Planning from "../components/Planning";
import Services from "../components/Services";
import Technology from "../components/Technology";
import Portfolio_home from "../components/Portfolio_home";
import ContactForm from "../components/contact-form";
import Blog from "../components/Blog";
import { initializeAppScripts } from "../main";

const HomePage = () => {
  useEffect(() => {
    initializeAppScripts();
  }, []);

  return (
    <div>
      <Header />
      <HomeHeroSection />
      <AboutHeroPage />
      <Planning />
      <Services />
      <Technology />
      <Portfolio_home />
      <ContactForm />
      <Blog />
      <Footer />
    </div>
  );
};

export default HomePage;
